import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class Snowflake extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <path d="M14.69,11.425l-2.115-2.1a.422.422,0,0,0-.265-.111h-.622a.426.426,0,0,0-.265.111l-2.115,2.1a.431.431,0,0,0-.109.265v.62a.425.425,0,0,0,.109.262l2.115,2.1a.429.429,0,0,0,.265.113h.622a.419.419,0,0,0,.265-.113l2.115-2.1a.42.42,0,0,0,.109-.262v-.62A.425.425,0,0,0,14.69,11.425ZM13,12.012a.432.432,0,0,1-.113.263l-.612.608a.432.432,0,0,1-.264.11h-.024a.434.434,0,0,1-.264-.11l-.612-.608A.426.426,0,0,1,11,12.012v-.024a.436.436,0,0,1,.108-.266l.612-.606a.426.426,0,0,1,.264-.11h.024a.426.426,0,0,1,.264.11l.612.606a.442.442,0,0,1,.113.266Z" />
        <path d="M3.438,5.706,8.526,8.628A1.5,1.5,0,0,0,10.78,7.336V1.489a1.5,1.5,0,0,0-2.995,0V4.761L4.934,3.123a1.492,1.492,0,1,0-1.5,2.583Z" />
        <path d="M8.015,12.439a1.473,1.473,0,0,0,.068-.486,1.543,1.543,0,0,0-.055-.352,1.48,1.48,0,0,0-.7-.894L2.247,7.784A1.5,1.5,0,0,0,.2,8.331a1.48,1.48,0,0,0,.546,2.034L3.591,12,.749,13.632a1.492,1.492,0,1,0,1.5,2.581L7.332,13.29A1.483,1.483,0,0,0,8.015,12.439Z" />
        <path d="M9.4,15.177a1.48,1.48,0,0,0-.869.194L3.438,18.292a1.492,1.492,0,1,0,1.5,2.583l2.851-1.637v3.27a1.5,1.5,0,0,0,2.995,0V16.662A1.491,1.491,0,0,0,9.4,15.177Z" />
        <path d="M20.56,18.292l-5.087-2.921a1.475,1.475,0,0,0-.867-.194,1.491,1.491,0,0,0-1.386,1.485v5.846a1.5,1.5,0,0,0,3,0v-3.27l2.848,1.637a1.492,1.492,0,1,0,1.5-2.583Z" />
        <path d="M23.25,10.365,20.409,12l2.841,1.631a1.492,1.492,0,1,1-1.5,2.581L16.665,13.29a1.48,1.48,0,0,1-.679-.851,1.5,1.5,0,0,1-.015-.838,1.5,1.5,0,0,1,.694-.894l5.088-2.923a1.5,1.5,0,0,1,2.045.547A1.483,1.483,0,0,1,23.25,10.365Z" />
        <path d="M14.606,8.823a1.5,1.5,0,0,0,.867-.2L20.56,5.706a1.492,1.492,0,1,0-1.5-2.583L16.216,4.761V1.489a1.5,1.5,0,0,0-3,0V7.336A1.5,1.5,0,0,0,14.606,8.823Z" />
      </svg>
    );
  }
}

export default Snowflake;
